// Format seconds to MM:SS or HH:MM:SS
export function formatDuration(seconds) {
  if (!seconds || seconds === 0) return '0:00';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  return `${m}:${String(s).padStart(2, '0')}`;
}

// Format date — "dd-mm-yyyy" (butun ilova bo'ylab yagona format)
export function formatDate(date) {
  return formatDmy(date);
}

// Format datetime — "HH:MM dd-mm-yyyy" (soat dd-mm-yyyy)
export function formatDateTime(date) {
  return formatClockDate(date);
}

// "HH:MM" — 24 soatlik, mahalliy vaqt (operator jurnali uchun)
export function formatClock(date) {
  if (!date) return '';
  const d = new Date(date);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

// "dd-mm-yyyy" — kun-oy-yil
export function formatDmy(date) {
  if (!date) return '';
  const d = new Date(date);
  return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
}

// "HH:MM dd-mm-yyyy" — soat va sana birga
export function formatClockDate(date) {
  if (!date) return '';
  return `${formatClock(date)} ${formatDmy(date)}`;
}

// Format time only
export function formatTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleTimeString('uz-UZ', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

// Call status label in Uzbek
export function getStatusLabel(status) {
  const labels = {
    answered: 'Javob berildi',
    missed: 'Javobsiz',
    no_answer: 'Javobsiz',
    busy: 'Band',
    failed: 'Muvaffaqiyatsiz',
    voicemail: 'Ovozli xabar',
  };
  return labels[status] || status;
}

// Call status color
export function getStatusColor(status) {
  const colors = {
    answered: '#10b981',
    missed: '#ef4444',
    no_answer: '#f59e0b',
    busy: '#f97316',
    failed: '#6b7280',
  };
  return colors[status] || '#6b7280';
}

// Direction label in Uzbek
export function getDirectionLabel(direction) {
  const labels = {
    inbound: 'Kiruvchi',
    outbound: 'Chiquvchi',
    internal: 'Ichki',
  };
  return labels[direction] || direction;
}

// Operator status label
export function getOperatorStatusLabel(status) {
  const labels = {
    online: 'Onlayn',
    offline: 'Oflayn',
    break: 'Tanaffus',
    busy: 'Band',
  };
  return labels[status] || status;
}

// Operator status color
export function getOperatorStatusColor(status) {
  const colors = {
    online: '#10b981',
    offline: '#6b7280',
    break: '#f59e0b',
    busy: '#ef4444',
  };
  return colors[status] || '#6b7280';
}

// Trunk status label
export function getTrunkStatusLabel(status) {
  const labels = {
    registered: 'Ulangan',
    connecting: 'Ulanmoqda',
    rejected: 'Rad etildi',
    unregistered: 'Ulanmagan',
    unknown: 'Noma\'lum',
    error: 'Xato',
  };
  return labels[status] || status;
}

// Pul summasi: "1 112 400 so'm" — mingliklar bo'sh joy bilan (operator mijozga
// aynan shu raqamni o'qib beradi, shuning uchun qisqartirilmaydi).
export function formatSum(n) {
  const v = Math.round(Number(n) || 0);
  const sign = v < 0 ? '-' : '';
  return `${sign}${String(Math.abs(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} so'm`;
}
